<template>
  <div class="nav-drawer">
    <v-navigation-drawer
      style="z-index: 1000000"
      v-model="drawer"
      location="right"
      temporary
      :width="props.windowWidth < 767 ? props.windowWidth / 2 : 370"
      class="pr-2 pl-3"
    >
      <div class="px-2 py-4" elevation="0" style="overflow: hidden">
        <div
          style="font-size: 17px; font-weight: bold; margin-top: -10px"
          class="d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center justify-space-between">
            <h2 class="text-wish">Wishlist</h2>
            <div style="position: relative; display: inline-block">
              <v-icon class="icon-wish" style="color: red; font-size: 48px">
                mdi-cards-heart
              </v-icon>
              <span
                style="
                  color: white;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-size: 16px;
                "
              >
                {{ allData.length }}
              </span>
            </div>
          </div>

          <v-hover v-slot:default="{ isHovering, props }">
            <div v-bind="props">
              <v-icon
                @click="drawer = false"
                style="font-size: 35px"
                :color="isHovering ? 'blue' : 'black'"
              >
                mdi-share-outline
              </v-icon>
            </div>
          </v-hover>
        </div>
        <v-card elevation="0" class="pa-0 mt-4" style="overflow-y: auto">
          <v-container>
            <v-row v-for="item in allData" :key="item.id">
              <v-col class="text-center">
                <img
                  :src="item.thumbnail ? item.thumbnail : item.image"
                  style="width: 100px; height: 100px"
                  alt=""
                />
                <div>
                  {{ item.title }}
                </div>
                <v-hover v-slot="{ isHovering, props }">
                  <div
                    v-bind="props"
                    style="display: inline-block; cursor: pointer"
                  >
                    <v-icon
                      @click="deleteItem(item.id)"
                      :color="isHovering ? 'red' : 'black'"
                      style="transition: color 0.2s"
                    >
                      {{ isHovering ? "mdi-delete-empty" : "mdi-delete" }}
                    </v-icon>
                  </div>
                </v-hover>
              </v-col>
              <v-divider class="mb-3"></v-divider>
            </v-row>
          </v-container>
          <v-card-text
            v-if="!allData.length"
            class="px-0 text-center"
            style="color: #6f6f6f"
          >
            Your wishlist is empty.
          </v-card-text>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<style lang="css">
@media (max-width: 480px) {
  .nav-drawer .text-wish {
    font-size: 17px;
  }
  .nav-drawer .icon-wish {
    font-size: 35px !important;
  }
}
</style>

<script setup>
import { ref, inject, onMounted, defineProps } from "vue";

const allData = ref([]);
const Emitter = inject("Emitter");
const drawer = ref(false);

const deleteItem = (itemId) => {
  const localStorageKeys = [
    "productsData",
    "phoneData",
    "freshvData",
    "womanData",
    "electronicsData",
  ];

  let itemFound = false;

  // الفحص في كل قسم من الـ localStorage
  localStorageKeys.forEach((key) => {
    const data = localStorage.getItem(key);
    if (data) {
      const items = JSON.parse(data);
      const index = items.findIndex((item) => item.id === itemId);

      if (index !== -1) {
        // إلغاء علامة "المفضلة" من العنصر
        items[index].wishlist = false; // أو قم بتعديل الخاصية المناسبة
        localStorage.setItem(key, JSON.stringify(items)); // تحديث الـ localStorage
        itemFound = true; // تم العثور على العنصر
        console.log(
          `Item with id ${itemId} has been removed from favorites in ${key}.`
        );
      }
    }
  });

  if (!itemFound) {
    console.warn(
      `Item with id ${itemId} not found in any localStorage section.`
    );
  }

  // تحديث allData بعد التعديل
  updateWishlist(); // تأكد من تحديث القائمة المعروضة
  Emitter.emit("getLocalStorage");
};

// دالة لتحديث قائمة العناصر
const updateWishlist = () => {
  const productsData = localStorage.getItem("productsData");
  const phonesData = localStorage.getItem("phoneData");
  const freshvData = localStorage.getItem("freshvData");
  const womanData = localStorage.getItem("womanData");
  const electronicsData = localStorage.getItem("electronicsData");

  const products = productsData ? JSON.parse(productsData) : [];
  const phones = phonesData ? JSON.parse(phonesData) : [];
  const food = freshvData ? JSON.parse(freshvData) : [];
  const womans = womanData ? JSON.parse(womanData) : [];
  const electronic = electronicsData ? JSON.parse(electronicsData) : [];

  allData.value = [
    ...products.filter((e) => e.wishlist),
    ...phones.filter((e) => e.wishlist),
    ...food.filter((e) => e.wishlist),
    ...womans.filter((e) => e.wishlist),
    ...electronic.filter((e) => e.wishlist),
  ];
};

Emitter.on("getLocalStorage", () => {
  updateWishlist();
});
Emitter.on("openWishlist", () => {
  drawer.value = true;
});
const props = defineProps({
  windowWidth: Number,
});

onMounted(() => {
  Emitter.on("openWishlist", () => {
    drawer.value = true;
  });
  updateWishlist();
});
</script>
